<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile"

// Service
import UsersDataService from "@/services/UsersDataService"
import MarketingDataService from "@/services/MarketingDataService";

// Helper
import UserUtils from '@/helpers/users'
import DateUtils from '@/helpers/date';
import Storage from '@/helpers/storage'

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import isEmpty from 'is-empty';


export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "App Updates",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },
  methods: {
    ...UserUtils,
    ...DateUtils,

    _isEmpty(val) {
      return isEmpty(val);
    },

    getMediaThumb() {
      if (!isEmpty(this.updates)) {
        this.updates.forEach(update => {
          if (update.photo && update.photo.length > 0)
            Storage.getUserMedia(update.userId, update.photo, 'appUpdate-user-' + update.userId);
        });
      }
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    handleDisplayChange() {
      this.page = 1;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      MarketingDataService.getAppUpdates(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.updates = items;
            this.count = totalItems;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.appUpdates.errorNoResult"));
          });
    },

    handlePageChange(value) {
      this.page = value;
      this.processFilters();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.toDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.fromDate = this.filters.toDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    trunc(value) {
      if (!isEmpty(value)) {
        if (value.length > 70)
          return value.substring(0, 70) + "…";
        else
          return value;
      }
      else {
        return "";
      }
    },

    getFilters() {
      MarketingDataService.getAppUpdatesFilters()
          .then(response => {
            response.data.filters.sdks.forEach(sdk => {
              this.filters.sdks.options.push(sdk);
            });

            response.data.filters.devices.forEach(device => {
              this.filters.devices.options.push(device);
            });
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.appUpdates.getFilters"));
          });
    },

    processFilters() {
      if (!this.isLoading)
        this.isLoading = true;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['sdks'] = this.filters.sdks.selected;
      params['devices'] = this.filters.devices.selected;
      params['origin'] = this.filters.origins.selected;

      MarketingDataService.getAppUpdates(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.updates = items;
            this.count = totalItems;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.appUpdates.errorNoResult"));
          });

      MarketingDataService.getAppUpdatesStats(params)
          .then(response => {
            this.stats.origins.series = response.data.origins.series;
            this.stats.origins.chartOptions = {...this.stats.origins.chartOptions, ...{
                labels: response.data.origins.labels
              }};

            this.stats.sdks.series = response.data.sdks.series;
            this.stats.sdks.chartOptions = {...this.stats.sdks.chartOptions, ...{
                labels: response.data.sdks.labels
              }};

            this.stats.devices.series = response.data.devices.series;
            this.stats.devices.chartOptions = {...this.stats.devices.chartOptions, ...{
                labels: response.data.devices.labels
              }};

            this.$refs.appUpdatesHistoryGraph.updateSeries([{
              name: "InApp Update",
              type: "column",
              data: response.data.historyGraph.originD
            }, {
              name: "Offline Update",
              type: "column",
              data: response.data.historyGraph.originO
            }]);

            this.total.updates = response.data.total.updates;
            this.total.originO = response.data.total.originO;
            this.total.originD = response.data.total.originD;
            this.isLoading = false;
          })
          .catch(error => {
            window.console.error(error);
            this.isLoading = false;
            this.$toast.error(this.$t("marketing.appUpdates.errorNoResult"));
          })
    },

    getGenderImg(sex) {
      return require('@/assets/images/'+(sex === 1?'man':'woman')+'.png')
    },


    showContextMenu(event, user) {
      if (!isEmpty(user.userId))
        this.$refs.appUpdatesContextMenu.showMenu(event, user)
    },

    processContextMenu(event) {
      const { item, option } = event;
      switch (option.value) {
        case "show":
          this.showUser(item.userId);
          break;

        case "search":
          this.searchUser(item.userId);
          break;
      }
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },

  data() {
    return {
      stats: {
        sdks: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-updates-sdk',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },
            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        devices: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-updates-devices',
              type: 'donut',
            },
            dataLabels: {
              enabled: true
            },
            labels:[],
            noData: {
              text: 'Loading...'
            },
            legend: {
              position: 'left'
            },
          }
        },
        origins: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-updates-origins',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },

            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        historyGraph: {
          series:[],
          chartOptions: {
            chart: {
              id: 'app-updates-history',
              stacked: true,
              type: 'bar',
              height: 350,
              zoom: {
                autoScaleYaxis: true
              },

              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                  reset: true
                }
              }
            },
            colors: ['#34c38f', '#77B6EA'],
            dataLabels: {
              enabled: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 0
                },
                hideOverlappingLabels: true
              }
            },
            stroke: {
              curve: 'smooth',
              width: 2
            },
            noData: {
              text: 'Loading...'
            }
          },
        }
      },
      total: {
        updates: 0,
        originO: 0,
        originD: 0,
      },
      updates: [],
      page: 1,
      count: 0,
      isLoading: true,
      title: this.$t("menuitems.marketing.updates"),
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      filters: {
        fromDate: null,
        toDate: null,
        sdks: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All SDKs'
          }]
        },
        origins: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Origins'},
            {value: 'D', text: 'Only InApp'},
            {value: 'O', text: 'Only Offline'}
          ]
        },
        devices: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Devices'
          }]
        },
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
              {value:'today', text:this.$t("dates.today")},
              {value:'yesterday', text:this.$t("dates.yesterday")},
              {value:'week', text:this.$t("dates.week")},
              {value:'curMonth', text:this.$t("dates.curMonth")},
              {value:'last30Day', text:this.$t("dates.last30Day")},
              {value:'lastMonth', text:this.$t("dates.lastMonth")},
              {value:'last3Month', text:this.$t("dates.last3Month")},
              {value:'curYear', text:this.$t("dates.curYear")},
              {value:'always', text:this.$t("dates.always")},
              {value:'custom', text:this.$t("dates.custom")}
          ]
        }
      },

      optionsContext: [
        {
          name: this.$t("show_user"),
          value: 'show'
        },
      ],

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    };
  },

  mounted() {
    this.getFilters();
    this.processFilters();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Filters -->
      <div class="card">
        <div class="card-body row">
          <b-form inline class="row gy-2 gx-3 align-items-center" id="appUpdatesFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="appUpdatesDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- SDKs -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUpdateSdkFilter"
                  v-model="filters.sdks.selected"
                  class="form-select me-lg-1"
                  :options="filters.sdks.options">
              </b-form-select>
            </div>

            <!-- Devices -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUpdatesDevicesFilter"
                  v-model="filters.devices.selected"
                  class="form-select me-lg-1"
                  :options="filters.devices.options">
              </b-form-select>
            </div>

            <!-- Devices -->
            <div class="col-sm-auto">
              <b-form-select
                  id="appUpdatesOriginsFilter"
                  v-model="filters.origins.selected"
                  class="form-select me-lg-1"
                  :options="filters.origins.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Stats Plain -->
      <div class="row">
        <!-- appUpdates -->
        <div class="col-lg-4">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">App-Updates</p>
                  <h5 class="mb-0">{{ total.updates }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-info rounded-circle white font-size-20"
                  >
                    <i class="bx bx-download"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- originD -->
        <div class="col-lg-4">
          <div class="card blog-stats-wid ">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">InApp Updates</p>
                  <h5 class="mb-0">{{ total.originD }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-success text-white rounded-circle font-size-20"
                  >
                    <i class="bx bxs-folder-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Logged -->
        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Offline Updates</p>
                  <h5 class="mb-0">{{ total.originO }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-pink rounded-circle text-white font-size-20"
                  >
                    <i class="bx bxs-right-arrow-square"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Charts -->
      <div class="row">
        <div class="col-12 col-lg-4">

          <div class="card">
            <div class="card-body" id="cardChartDevices">
              <h5 class="card-title">Devices</h5>
              <apexchart
                  ref="appUpdatesDevicesChart"
                  height="250"
                  type="donut"
                  dir="ltr"
                  :series="stats.devices.series"
                  :options="stats.devices.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-4">

          <div class="card">
            <div class="card-body" id="cardChartSDK">
              <h5 class="card-title">SDK</h5>
              <apexchart
                  ref="appUpdatesSDKChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.sdks.series"
                  :options="stats.sdks.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-4">

          <div class="card">
            <div class="card-body" id="cardChartOrigins">
              <h5 class="card-title">Origins</h5>
              <apexchart
                  ref="appUpdatesOriginsChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.origins.series"
                  :options="stats.origins.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Charts 2 -->
      <div class="row">

        <div class="col-12">

          <div class="card">
            <div class="card-body" id="cardChartHistory">
              <h5 class="card-title">App-Updates History</h5>
              <apexchart
                  ref="appUpdatesHistoryGraph"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="stats.historyGraph.series"
                  :options="stats.historyGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="appUpdates-list"
            ></b-pagination>
            </div>
        </div>
      </div>

      <div class="row bg-white" v-if="!isLoading && updates.length > 0">
        <!-- Result list -->
        <div class="table-responsive">
          <table
              id="appUpdates-list"
              class="table project-list-table table-nowrap table-centered table-borderless align-middle">
            <thead>
            <tr>
              <th scope="col">{{ $t("appUpdates.startUpdateAt") }}</th>
              <th scope="col">{{ $t("appUpdates.newVersion") }}</th>
              <th scope="col">{{ $t("appUpdates.oldVersion") }}</th>
              <th scope="col">{{ $t("appUpdates.device") }}</th>
              <th scope="col">{{ $t("appUpdates.user") }}</th>
              <th scope="col">{{ $t("appUpdates.origin") }}</th>
              <th scope="col">{{ $t("appUpdates.data") }}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="appUpdate in updates" :key="appUpdate.documentId" @contextmenu.prevent.stop="showContextMenu($event, appUpdate)">
              <td>
                <p class="text-muted font-size-12">
                  {{ formatDateString(appUpdate.startUpdateAt, 'DD MMM YYYY HH:mm') }}<br>
                </p>
              </td>
              <td>
                <span class="badge bg-success text-light">{{ appUpdate.newVersionCode }}</span>
              </td>
              <td>
                <span class="badge bg-light text-dark">{{ appUpdate.currentVersionCode }}</span>
                <small class="text-muted">{{ appUpdate.currentVersionName }}</small>
              </td>
              <td>
                <p class="text-muted font-size-12">
                  <small>{{ appUpdate.deviceManufacturer }}</small>
                  <br><b>{{ appUpdate.deviceModel }}</b>
                  <br>SDK: {{ appUpdate.deviceSdk }}
                </p>
              </td>
              <td>
                <div class="media" v-if="!_isEmpty(appUpdate.userId)">
                  <div class="avatar-xs">
                    <img
                        :id="`appUpdate-user-${appUpdate.userId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-1">
                    <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': appUpdate.sex === 1,
                          'text-danger': appUpdate.sex === 2,
                          'text-dark': appUpdate.sex === 0,
                        }"
                      >
                        {{ appUpdate.name || '-' }}
                      </span> {{ getAge(appUpdate.birth) }}</h5>
                    <small class="text-muted">#{{ appUpdate.userId }}</small>
                  </div>
                </div>
              </td>
              <td>
                <b>{{ $t(`appUpdates.origin${appUpdate.originUpdate}`) }}</b>
              </td>
              <td>
                <p class="text-muted font-size-12">
                  <small>{{ appUpdate.documentId}}</small>
                  <br>{{ appUpdate.totalBytes}} KB
                </p>
              </td>

            </tr>
            </tbody>
          </table>
        </div>
        <!-- END Result list -->
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && updates.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No AppUpdates were found for these filters. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="appUpdates-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <vue-simple-context-menu
        element-id="appUpdatesContextMenu"
        :options="optionsContext"
        ref="appUpdatesContextMenu"
        @option-clicked="processContextMenu"
    />

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>
  .gender-img {
    max-width: 30px;
    margin-right: 10px;
  }

  .cursor-pointer {
    cursor:pointer;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
